//---------	Global imports
import React from 'react';

//---------	Plugins
import { forEach, includes, remove } from 'lodash';

//---------	Styles
import './styles.sass';


class ProductsFilters extends React.Component {
  
  //---------	Constructor
  constructor(props) {
    super();
    
    this.categories = props.categories;
    this.browseAll = true;
    this.state = {
      filters: []
    };
    
    this.filter = this.filter.bind(this);
    this.setActiveClass = this.setActiveClass.bind(this);
  }
  
  
  //---------	React functions
  componentDidMount() {
    this.props.onRef(this);
  }
  
  componentWillUnmount() {
    this.props.onRef(undefined);
  }
  
  
  //---------	Custom functions
  filter(product) {
    let filters = this.state.filters;
    
    if (product === 'all' || filters.length === this.categories.length) {
      filters = [];
      this.browseAll = true;
    } else {
      this.browseAll = false;
      includes(filters, product) ? remove(filters, (filter) => filter === product) : filters.push(product);
    }
    this.setState({filters: filters}, () => {
      
      if (this.state.filters.length === this.categories.length || this.state.filters.length === 0) {
        this.state.filters = [];
        this.browseAll = true;
      }
      this.props.filters(this.state.filters);
    });
  }
  
  setActiveClass(category) {
    return !includes(this.state.filters, category) ? 'CalipsyProductsFilters-filter state-active' : 'CalipsyProductsFilters-filter';
  }
  
  renderFiltersList() {
    const filtersList = [];
    
    filtersList.push(<span key="all"
                           className={this.browseAll ? 'CalipsyProductsFilters-filter state-active' : 'CalipsyProductsFilters-filter'}
                           onClick={() => this.filter('all')}><i>show all</i></span>);
    
    forEach(this.categories, (category) => {
      filtersList.push(<span key={category} className={this.setActiveClass(category)}
                             onClick={() => this.filter(category)}><i>{category}</i></span>);
    });
    
    return filtersList;
  }
  
  
  //---------	Render
  render() {
  
    let browseAllClass = this.browseAll ? 'CalipsyProductsFilters-filters state-browseAll' : 'CalipsyProductsFilters-filters';
    return (
      <div className={browseAllClass}>
        {this.renderFiltersList()}
        <button className="CalipsyButton CalipsyButton-blue" onClick={() => this.props.toggleSidebar('sendToast')}>
          Update results
        </button>
      </div>
    );
  }
}

export default ProductsFilters;


// WEBPACK FOOTER //
// ./src/components/ProductsFilters/index.js